import {
  FETCH_PRORATION_BEGIN,
  FETCH_PRORATION_SUCCESS,
  FETCH_PRORATION_FAILURE
} from "../actions/types";

const initialState = {
  proration: {},
  loading: false,
  error: null
};

export default function proration(state = initialState, action) {
  switch (action.type) {
    case FETCH_PRORATION_BEGIN:
      return {
        ...state,
        loading: true,
        proration: {},
        error: null
      };
    case FETCH_PRORATION_SUCCESS:
      return {
        ...state,
        loading: false,
        proration: action.payload,
        error: null
      };
    case FETCH_PRORATION_FAILURE:
      return {
        ...state,
        loading: false,
        proration: {},
        error: action.payload
      };
    default:
      return state;
  }
}
